<template>
  <!-- Android Chrome/Edge: Automatic install prompt -->
  <Teleport to="body" v-if="canInstall && !dismissed">
    <div class="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-end justify-center">
      <div class="bg-gray-900 rounded-t-2xl p-6 animate-slide-up w-full md:max-w-md mx-auto shadow-lg">
        <div class="flex items-center gap-4 mb-4">
          <img src="/icons/vapp-192.png" alt="Viva" class="w-16 h-16 rounded-lg">
          <div class="flex-1">
            <h2 class="text-xl font-bold text-gray-200">نصب برنامه Viva</h2>
            <p class="text-sm text-gray-200 mt-1">دسترسی سریع‌تر و بدون نیاز به مرورگر</p>
          </div>
        </div>

        <p class="text-gray-200 text-sm mb-6 leading-relaxed">
          برنامه Viva را روی صفحه خانگی خود نصب کنید و با سرعت بیشتری دسترسی داشته باشید.
        </p>

        <div class="flex gap-3">
          <button
              @click="dismiss"
              class="flex-1 px-4 py-3 text-gray-200 bg-gray-800 border border-solid border-gray-600 rounded-lg font-semibold hover:bg-gray-700 transition"
          >
            بعداً
          </button>
          <button
              @click="handleInstall"
              class="flex-1 px-4 py-3 text-white border border-solid border-gray-600 outline-none focus:outline-none rounded-lg font-semibold transition"
              style="background-color: #ec561e"
              @mouseenter="$event.target.style.backgroundColor = '#d4471a'"
              @mouseleave="$event.target.style.backgroundColor = '#ec561e'"
          >
            نصب کن
          </button>
        </div>
      </div>
    </div>
  </Teleport>

  <!-- iOS Safari: Manual install instructions -->
  <Teleport to="body" v-if="showIosPrompt">
    <div class="fixed inset-0 bg-black bg-opacity-70 z-50 flex items-end justify-center">
      <div class="bg-gray-900 rounded-t-2xl p-6 animate-slide-up w-full md:max-w-md mx-auto shadow-lg">
        <div class="flex items-center gap-4 mb-4">
          <img src="/icons/vapp-192.png" alt="Viva" class="w-16 h-16 rounded-lg">
          <div class="flex-1">
            <h2 class="text-xl font-bold text-gray-200">نصب برنامه Viva</h2>
            <p class="text-sm text-gray-200 mt-1">دسترسی آسان‌تر و سریع‌تر</p>
          </div>
        </div>

        <div class="mb-6 space-y-4">
          <p class="text-gray-200 text-sm leading-relaxed">
            برنامه Viva را نصب کنید و مستقیم از صفحه خانگی خود دسترسی داشته باشید.
          </p>

          <div class="rounded-lg p-4" style="background-color: rgba(236, 86, 30, 0.1); border: 1px solid #ec561e;">
            <p class="text-sm font-semibold mb-3" style="color: #ec561e;">📱 نحوه نصب:</p>
            <ol class="text-xs space-y-2 list-decimal list-inside" style="color: #ec561e;">
              <li>روی دکمه <span class="font-semibold">Share</span> share کلیک کنید</li>
              <li>گزینه <span class="font-semibold">Add to Home Screen</span> را انتخاب کنید</li>
              <li>نام تایید کنید و <span class="font-semibold">Add</span> را کلیک کنید</li>
            </ol>
          </div>
        </div>

        <button
            @click="dismissIosPrompt"
            class="w-full px-4 py-3 text-white rounded-lg font-semibold transition"
            style="background-color: #ec561e"
            @mouseenter="$event.target.style.backgroundColor = '#d4471a'"
            @mouseleave="$event.target.style.backgroundColor = '#ec561e'"
        >
          متوجه شدم
        </button>
      </div>
    </div>
  </Teleport>
</template>

<script lang="ts" setup>
const {canInstall, showIosPrompt, install, dismissIosPrompt} = usePwaInstall()
const dismissed = ref(false)

const handleInstall = async () => {
  await install()
}

const dismiss = () => {
  dismissed.value = true
}

const openSafariShare = () => {
  // This just closes the modal and shows instructions
  // User needs to manually tap Share button on their device
  dismissIosPrompt()
}
</script>

<style scoped>
@keyframes slideUp {
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
}

.animate-slide-up {
  animation: slideUp 0.3s ease-out;
}
</style>
